import { useEffect, useRef } from "react";
import { Popover } from "bootstrap";

const InfoPopover = ({
  content,
  placement = "top",
  offset = "0,8",
  allowHtml = false,
  children,
}) => {
  const triggerRef = useRef(null);

  useEffect(() => {
    if (!triggerRef.current) return;

    const popover = new Popover(triggerRef.current, {
      trigger: "click",
      placement,
      offset,
      content,
      html: allowHtml,
      customClass: "reta-popover",
      container: "body",
    });

    return () => {
      popover.dispose();
    };
  }, [content, placement, offset, allowHtml]);

  return (
    <span
      ref={triggerRef}
      role="button"
      tabIndex={0}
      style={{ cursor: "pointer", display: "inline-flex" }}
    >
      {children}
    </span>
  );
};

export default InfoPopover;
